module.exports = __webpack_public_path__ + "static/media/boring_DAO.4d318550.png";